<template>
  <div class="text-center pa-4" style="background: #f8fafc none repeat scroll 0 0; padding: 0 !important;">
    <div v-if="companyData && companyData.company_billing_entries && companyData.company_billing_entries.length > 0">
    <v-expansion-panels style="    justify-content: flex-start;     background: #c5c5d8 !important;">
      <v-row class="w-100 ma-0 am-table-title" style="text-align: left;
    padding: 16px 24px;
    max-width: 97%;">
          <v-col cols="2">
            S. No.
          </v-col>
          <v-col cols="3">
            Billing date
          </v-col>
          <v-col cols="3">
            Contract valid upto
          </v-col>
          <v-col cols="3">
            Total ARR
          </v-col>
          <v-col cols="1">
            Action
          </v-col>
        </v-row>
    <v-expansion-panel
      v-for="(bill, b) in companyData.company_billing_entries.reverse()" :key="b"
    >
      <v-expansion-panel-header>
        
        <v-row class="w-100 ma-0 am-table-title">
          <v-col cols="2">
            AM00{{ b+1 }}
          </v-col>
          <v-col cols="3">
            <span v-if="bill.billing_start_date">{{bill.billing_start_date}}</span> <span style="font-weight:bold;" v-else>--</span>
          </v-col>
          <v-col cols="3">
            <span v-if="bill.contract_valid_upto">{{bill.contract_valid_upto}}</span> <span style="font-weight:bold;" v-else>--</span>
          </v-col>
          <v-col cols="3">
            <span v-if="bill.total_arr">{{bill.total_arr}}</span> <span style="font-weight:bold;" v-else>--</span>
          </v-col>
          <v-col cols="1">
            <v-btn icon small @click.stop="openFinanceModal(bill)">
              <v-icon>mdi-pencil</v-icon>
            </v-btn>
          </v-col>
        </v-row>
      </v-expansion-panel-header>
      <v-divider class="mt-0 mb-0"></v-divider>
      <v-expansion-panel-content>
        <p class="mb-0 mt-4 text-left pl-3" style="font-weight: 600;padding-top:10px;font-size:18px;">Billing details {{ b+1 }}</p>
                  <v-row class="w-100 ma-0 text-left">
                    <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Billing region</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.billing_region">{{bill.billing_region}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                    </div>
                    </div>
                  </v-col>
                  <v-col cols="4">
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Allocated user</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.user_booked">{{bill.user_booked}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Billing date</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.billing_start_date">{{bill.billing_start_date}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Contract start date</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.contract_start_date">{{bill.contract_start_date}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Contract renewal date</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.contract_renewal_date">{{bill.contract_renewal_date}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Contract valid upto</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.contract_valid_upto">{{bill.contract_valid_upto}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Rate per user</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.rate_per_user">{{bill.rate_per_user}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Total subscription cost</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.total_subscription_cost">{{bill.total_subscription_cost}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">One time setup cost</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.one_time_setup_cost">{{bill.one_time_setup_cost}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">HRIS integration cost</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.hris_integration_cost">{{bill.hris_integration_cost}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Subsequent invoice amount</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.subsequent_invoice_amount">{{bill.subsequent_invoice_amount}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Billing model</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.billing_model">{{bill.billing_model}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Payment mode</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.payment_mode">{{bill.payment_mode}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Payment frequency</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.payment_frequency">{{bill.payment_frequency}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Total annual recurring revenue (ARR)</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.total_arr">{{bill.total_arr}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Company invoicing</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.company_invoicing">{{bill.company_invoicing}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Company total billing with tax</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.company_total_billing_with_tax">{{bill.company_total_billing_with_tax}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                  <v-col cols="4" >
                    <div style="padding:0 10px; ">
                      <p class="mb-0" style="font-size: 80%;">Total payment received</p>
                      <div style="">
                      <span style="font-weight:bold;" v-if="bill.total_payment_received">{{bill.total_payment_received}}</span>
                      <span style="font-weight:bold;" v-else>--</span>
                      </div>
                    </div>
                  </v-col>
                </v-row>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </v-expansion-panels>
    
      <v-card class="hover-elevation" style="box-shadow:none;border-radius: 24px;" >
                  
                </v-card>
                </div>
                <div v-else>
      <div class="firstNew" style="width:100%;background: white;border-radius: 10px; height: 300px;; ">
          <p class="text-center" style="    color: rgb(135, 136, 136);
        padding: 75px;
    margin: 0px;
    text-align: center !important;">No billing entries available</p>
        </div>
    </div>

                <v-dialog v-model="open" persistent max-width="800">
                  <v-card class="background: white;">
      <v-card-title>
        Add new billing entry
      </v-card-title>
      <v-card-text style="max-height: 400px; overflow-y: auto;" class="pt-4">
        <div>
        <v-form
              ref="form4"
              v-model="valid4"
              lazy-validation
            >
              <v-container class="text-left">
                <strong>Billing details</strong>
                <v-row class="mt-2 test-class">
                  <v-col cols="4" class="py-0">
                      <label>Billing region</label>
                        <v-text-field
                          v-model="billing.billing_region"
                          name="billing_region"
                          placeholder="Enter billing region"
                          outlined
                          dense
                        ></v-text-field>
                      </v-col>
                  <v-col class="py-0" cols="4">
                    <label>Allocated user</label>
                    <v-text-field
                      v-model="billing.user_booked"
                      placeholder="Enter the number of users booked"
                      maxlength="9"
                      outlined dense
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="4">
                    <label>Billing date</label>
                    <v-menu
                      v-model="billingDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          required
                          dense
                          readonly
                          @input="changeFormat()"
                          name="Billing date"
                          placeholder="Billing date"
                          v-model="billing.billing_start_date"
                          @blur="date1 = parseDate(billing.billing_start_date)"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="billing_start_date " @input="billingDateMenu = false, changeFormat()">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" cols="4">
                    <label>Contract start date</label>
                    <v-menu
                      v-model="contractStartDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          required
                          dense
                          readonly
                          @input="changeFormat()"
                          name="Contract start date"
                          placeholder="Contract start date"
                          v-model="billing.contract_start_date"
                          @blur="date1 = parseDate(billing.contract_start_date)"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="contract_start_date " @input="contractStartDateMenu = false, changeFormat()">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" cols="4">
                    <label>Contract renewal date</label>
                    <v-menu
                      v-model="contractRenewalDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          required
                          dense
                          readonly
                          @input="changeFormat()"
                          name="Contract renewal date"
                          placeholder="Contract renewal date"
                          v-model="billing.contract_renewal_date"
                          @blur="date1 = parseDate(billing.contract_renewal_date)"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="contract_renewal_date " @input="contractRenewalDateMenu = false, changeFormat()">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col class="py-0" cols="4">
                    <label>Contract valid upto</label>
                    <v-menu
                      v-model="contractValidUPTOMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          outlined
                          required
                          dense
                          readonly
                          @input="changeFormat()"
                          name="Contract valid upto"
                          placeholder="Contract valid upto"
                          v-model="billing.contract_valid_upto"
                          @blur="date1 = parseDate(billing.contract_valid_upto)"
                          v-on="on"
                        ></v-text-field>
                      </template>
                      <v-date-picker v-model="contract_valid_upto" @input="contractValidUPTOMenu = false, changeFormat()">
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                  <v-col cols="4" class="py-0">
                      <label>Rate per user</label>
                        <v-text-field prepend-inner-icon="mdi mdi-currency-inr"
                          v-model="billing.rate_per_user"
                          placeholder="Enter rate per user" outlined
                          dense :rules="intRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4"  class="py-0">
                      <label>Total subscription cost</label>
                        <v-text-field prepend-inner-icon="mdi mdi-currency-inr"
                          v-model="billing.total_subscription_cost"
                          placeholder="Enter total subscription cost" outlined
                          dense :rules="intRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4"  class="py-0">
                      <label>One time setup cost</label>
                        <v-text-field prepend-inner-icon="mdi mdi-currency-inr"
                          v-model="billing.one_time_setup_cost"
                          placeholder="Enter One time setup cost" outlined
                          dense
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4"  class="py-0">
                      <label>HRIS integration cost</label>
                        <v-text-field prepend-inner-icon="mdi mdi-currency-inr"
                          v-model="billing.hris_integration_cost"
                          placeholder="Enter HRIS integration cost" outlined
                          dense :rules="intRules"
                        ></v-text-field>
                      </v-col>
                      <v-col cols="4"  class="py-0">
                      <label>Subsequent invoice amount</label>
                        <v-text-field prepend-inner-icon="mdi mdi-currency-inr"
                          v-model="billing.subsequent_invoice_amount"
                          placeholder="Enter subsequent invoice amount" outlined
                          dense :rules="intRules"
                        ></v-text-field>
                      </v-col>
                      <v-col class="py-0"
                    cols="4"
                  >
                    <label>Billing model</label>
                    <v-autocomplete
                      v-model="billing.billing_model"
                      :items="billingModelType"
                      placeholder="Select billing model"
                      outlined dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-0"
                    cols="4"
                  >
                    <label>Payment mode</label>
                    <v-autocomplete
                      v-model="billing.payment_mode"
                      :items="paymentModeType"
                      placeholder="Select payment mode"
                      outlined dense
                    ></v-autocomplete>
                  </v-col>
                  <v-col class="py-0"
                    cols="4"
                  >
                    <label>Payment frequency</label>
                    <v-autocomplete
                      v-model="billing.payment_frequency"
                      :items="paymentFrequencyType"
                      placeholder="Select payment frequency"
                      outlined dense
                      name="payment_frequency"
                    ></v-autocomplete>
                  </v-col>
                <v-col class="py-0 totalArrField"
                  cols="4"
                >
                <label>Total annual recurring revenue (ARR) </label>
                  <v-text-field 
                  prepend-inner-icon="mdi mdi-currency-inr"
                  v-model="billing.total_arr"
                  :rules="billing.total_arr ? intRules : ''"
                  placeholder="Total annual recurring revenue in INR (ARR) "
                  outlined dense
                ></v-text-field>
                </v-col>
                <v-col class="py-0 totalArrField"
                  cols="4"
                >
                <label>Company invoicing </label>
                  <v-text-field 
                  prepend-inner-icon="mdi mdi-currency-inr"
                  v-model="billing.company_invoicing"
                  :rules="billing.company_invoicing ? intRules : ''"
                  placeholder="Enter company invoicing amount "
                  outlined dense
                ></v-text-field>
                </v-col>
                <v-col class="py-0 totalArrField"
                  cols="4"
                >
                <label>Company total billing with tax </label>
                  <v-text-field 
                  prepend-inner-icon="mdi mdi-currency-inr"
                  v-model="billing.company_total_billing_with_tax"
                  :rules="billing.company_total_billing_with_tax ? intRules : ''"
                  placeholder="Enter company total billing with tax amount"
                  outlined dense
                ></v-text-field>
                </v-col>
                <v-col class="py-0 totalArrField"
                  cols="4"
                >
                <label>Total payment received</label>
                  <v-text-field 
                  prepend-inner-icon="mdi mdi-currency-inr"
                  v-model="billing.total_payment_received"
                  :rules="billing.total_payment_received ? intRules : ''"
                  placeholder="Enter total payment received amount"
                  outlined dense
                ></v-text-field>
                </v-col>
                </v-row>
              </v-container>
            </v-form>
      </div>
    </v-card-text>
    <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          text
          @click="closeModal()"
        >
          Cancel
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn v-if="editView" :loading="loading" style="color:white;"
          color="#10b981"
          class="white--text"
          @click="addBill()"
        >
          Update
        </v-btn>
        <v-btn v-if="!editView" style="color:white;"
          color="#10b981" :loading="loading"
          class="white--text"
          @click="addBill()"
        >
          Add
        </v-btn>
      </v-card-actions>
    </v-card>
    </v-dialog>
  </div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import moment from 'moment';
import infiniteScroll from 'vue-infinite-scroll';
import { mapState } from 'vuex';

export default {
  name: 'companyList',

  components: {
    axios,
    infiniteScroll
  },

  data: () => ({
    billingID: null,
    editView: false,
    moment: moment,
    open: false,
    billing: {},
    data: [],
    paymentModeType: ['Bank transfer'],
    paymentFrequencyType: ['Monthly', 'Quarterly', 'Half-yearly', 'Yearly'],
    billingModelType: ['active_users', 'unique_users'],
    companyData: null,
    loading: false,
    avatarList: [],
    pagination: {
      rowsPerPage: 10,
      page: 1,
      length: 1
    },
    go_live_date: '',
    renewal_date: '',
    billing_start_date: '',
    contract_start_date: '',
    contract_renewal_date: '',
    contract_valid_upto: '',
    joinDateMenu: false,
    renewalDateMenu: false,
    billingDateMenu: false,
    contractStartDateMenu: false,
    contractRenewalDateMenu: false,
    contractValidUPTOMenu: false,
    busy: false,
    searchCompany: '',
    filter_type: null,
    emailTemplate: null,
    companyAccountData: null,
  }),
  watch : {
    go_live_date (val) {
      const [year, month, day] = this.go_live_date.split('-');
      this.company.activatedAt = `${day}-${month}-${year}`;
    },
    billing_start_date (val) {
      const [year, month, day] = this.billing_start_date.split('-');
      this.billing.billing_start_date = `${day}-${month}-${year}`;
    },
    contract_start_date (val) {
      const [year, month, day] = this.contract_start_date.split('-');
      this.billing.contract_start_date = `${day}-${month}-${year}`;
    },
    contract_renewal_date (val) {
      const [year, month, day] = this.contract_renewal_date.split('-');
      this.billing.contract_renewal_date = `${day}-${month}-${year}`;
    },
    contract_valid_upto (val) {
      const [year, month, day] = this.contract_valid_upto.split('-');
      this.billing.contract_valid_upto = `${day}-${month}-${year}`;
    },
    renewal_date (val) {
      const [year, month, day] = this.renewal_date.split('-');
      this.company.renewal_date = `${day}-${month}-${year}`;
    },
    start_date () {
      this.minDate1 = this.start_date_formated;
      this.maxDate1 = dayjs(this.start_date_formated).add(1, 'month').format();
    },
    start_date_formated () {
      const [year, month, day] = this.start_date_formated.split('-');
      this.company_settings.pause_interaction_start_date = `${day}-${month}-${year}`;
      this.maxDate1 = dayjs(this.start_date).add(1, 'month').format();
    },
    end_date_formated () {
      const [year, month, day] = this.end_date_formated.split('-');
      this.company_settings.pause_interaction_end_date = `${day}-${month}-${year}`;
    },
  },
  computed: {
    ...mapState({
      snackbar: state => state.snackbar,
      user: state => state.user
    })
  },
  mounted () {
    this.getCompanyDetails(this.$route.query.cid);
  },
  methods: {
    openFinanceModal (bill) {
      this.editView = true;
      this.open = true;
      this.billing = bill;
      this.billingID = bill.id;
    },
    addBill () {
        if (this.billing?.extra_data) {
          delete this.billing.extra_data;
          delete this.billing.created_at;
          delete this.billing.last_updated;
          delete this.billing.id;
          delete this.billing.company;
        }
        const formData = new FormData();
        this.$lodash.each(this.billing, (val, key) => {
          if (key === 'contract_start_date' && this.billing.contract_start_date) {
          const [day, month, year] = this.billing.contract_start_date.split('-');
          this.billing.contract_start_date = `${year}-${month}-${day}`;
          formData.append('billing__contract_start_date', this.billing.contract_start_date);
        } else if (key === 'contract_renewal_date' && this.billing.contract_renewal_date) {
          const [day, month, year] = this.billing.contract_renewal_date.split('-');
          this.billing.contract_renewal_date = `${year}-${month}-${day}`;
          formData.append('billing__contract_renewal_date', this.billing.contract_renewal_date);
        } else if (key === 'contract_valid_upto' && this.billing.contract_valid_upto ) {
          const [day, month, year] = this.billing.contract_valid_upto.split('-');
          this.billing.contract_valid_upto = `${year}-${month}-${day}`;
          formData.append('billing__contract_valid_upto', this.billing.contract_valid_upto);
        } else if (key === 'billing_start_date' && this.billing.billing_start_date) {
          const [day, month, year] = this.billing.billing_start_date.split('-');
          this.billing.billing_start_date = `${year}-${month}-${day}`;
          formData.append('billing__billing_start_date', this.billing.billing_start_date);
        } else if (val || val === 0) {
          formData.append(`billing__${key}`, val);
        }
        });
        if (this.billingID) {
          formData.append('billing__id', this.billingID);
        }
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.patch(`${process.env.VUE_APP_API_URL}company/update/${this.$route.query.cid}`, formData, {
          withCredentials: true,
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }).then((response) => {
          if (response && response.data) {
            this.loading = false;
            this.closeModal();
            this.getCompanyDetails(this.$route.query.cid);
            this.dashboardData = response.data;
            this.$store.dispatch('updateSnackbar', {
              color: 'success',
              show: true,
              text: 'Billing updated successfully!'
            });
            this
            setTimeout(() => {
              this.company_settings = {
                chat_alert_word_notification:false,
                disengaged_auto_assign:false,
                passively_engaged_auto_assign:false,
                enable_brand_promotion_feedback:false,
                enable_action_summary:"0",
                auto_acknowledge:false
              }
              this.plan = {
                  title:'',
                  account_type: 'paid',
                  adhoc_active:false,
                  exit_active: false,
                  employee_wellbeing_active: false,
                  employee_recognition_active: false,
                  adhoc_limit:10,
                  milestone_active:true,
                  milestone_limit:50
              }
              this.changeLogo();
            }, 100);
          }
        }).catch((err) => {
          this.loading = false;
          if (err.response.status === 400) {
            if (err.response.data.title) {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: `Company name : ${err.response.data.title[0]}`
              });
            }
            if (err.response.data.employee_strength) {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: `Employee strength : ${err.response.data.employee_strength[0]}`
              });
            }
            if (err.response.data.spoc_email) {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: `SPOC email : ${err.response.data.spoc_email[0]}`
              });
            }
            
            if (err.response.data.spoc_phone) {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: `SPOC phone : ${err.response.data.spoc_phone[0]}`
              });
            }
            if (!err.response.data.spoc_email && !err.response.data.employee_strength) {
              this.$store.dispatch('updateSnackbar', {
                color: 'error',
                show: true,
                text: err.response.data
              });
            }
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
    },
    closeModal () {
      this.open = false;
      this.billing = {};
      this.billingID = null;
      this.editView = false;
    },
    getCompanyDetails (id) {
        this.isLoadingData = true;
        // axios.defaults.headers.common.Authorization = `JWT ${this.user.access_token}`;
        axios.get(`${process.env.VUE_APP_API_URL}company/profile/${id}?fields=company_name,brand_name,spoc_name,allow_stage_edit,spoc_email,spoc_phone,country,company_address,company_logo,createdBy,company_type,chat_cobranding_enabled,createdAt,is_active,employee_strength,chat_cobranding_enabled,tags,facebook_link,linkedin_link,glassdoor_link,jobStreet_link,activatedAt,user_booked,users_status,companies_avatar,company_avatar,total_arr,renewal_date,is_visible_in_admin_panel,employee_data_source&company_dashboard_details=engagement_score,disengaged_employees_stats,fence_sitters_employees_stats,user_participation_stats,company_employee_reach_stats`, {
          withCredentials: true
        }).then((response) => {
          if (response && response.data) {
            this.companyData = response.data;
            this.isLoadingData = false;
          }
        }).catch((err) => {
          if (err.response.status === 429) {
            this.config.savingStage = false;
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: err.response.data.error
            });
          } else {
            this.$store.dispatch('updateSnackbar', {
              color: 'error',
              show: true,
              text: 'Unable to fetch details, Please try again later!'
            });
          }
        });
      },
    editCompany (data) {
      this.$router.push(`/company-details?cid=${data.id}&editview=true`);
    },
  },
}
</script>
<style lang="scss" >
.v-expansion-panel-header__icon {
  .v-icon {
    font-size: 14px;
  }
}
.heading {
  font-size: 12px;
  padding-top:10px;
}
.dashboardCount {
  font-size: 70px;
  padding:10%;
}
.mainBox {
    background-color: white;
    border-radius: 6px;
    box-shadow: 0 4px 16px 11px rgb(0 0 0 / 6%), 0 4px 8px rgb(0 0 0 / 10%) !important;
    height: 16rem;
    transition: 0.5s;
    -webkit-transition: 0.5s;
    text-align: center;
}
.v-btn--active {
    background-color: #050550 !important;
  }
.disabledView {
  .v-btn--active {
    background-color: #858585 !important;
  }
}
#chartdiv1 {
  height: 400px;
  width:100%;
}

.primary--text {
  color: #050550 !important;
}
#chartdiv {
  width: 100%;
  height: 210px;
  
}
.headingprofile {
  text-align: left;
  h2 {
    color: #263238;
    font-weight: 500;
    line-height: 1.1;
    font-size: 20px;
    margin: 0 0 6px;
    width: 100%;
  }
}
.box-detail {
  background-color: #f6f6f8;
  padding-left:10px;
  border-radius:6px;
}
</style>
